export function toggleTotalPremiumAndAdhesiveCalculator(modelOrder: any, constants: any) {
  let totalPremiumSealing = 0;
  let totalAdhesive = 0;
  let totalSelectedPremiumSealing = 0;
  let totalSelectedAdhesive = 0;
  let totalDisabledAdhesivePrice = 0;
  let totalDisabledSealerPrice = 0;

  if (modelOrder.quote_product?.length >= 1) {
    modelOrder.quote_product?.map((product: any) => {
      const p = product.product;
      // Mirrors calculateTotalPremiumSealingAndAdhesivePrice(): a custom product carries no
      // apply_glue_calculator flag, so without this the adhesive was excluded from the totals
      // and modelOrder.is_select_adhesive stayed false — leaving the Order Summary's
      // "Total Premium Adhesive" checkbox unchecked while the row itself showed a real amount.
      const hasGlueCalc = p?.apply_glue_calculator === constants.APPLY_GLUE_CALCULATOR_YES || !!p?.is_custom_product;
      // Same allowance as hasGlueCalc above: a custom product has no consumables_finish_id, so
      // without this both totalPremiumSealing and totalDisabledSealerPrice stayed 0 — and the
      // `totalPremiumSealing == totalDisabledSealerPrice` test below then set
      // disabledTotalPremiumSealingPrice = true, hiding the Order Summary's "Total Premium Sealer"
      // row even though quote_summary.total_premium_sealing held a real amount.
      const hasFinishId = p?.consumables_finish_id || !!p?.is_custom_product;

      if (product.disabledAdhesivePrice && hasGlueCalc) {
        totalDisabledAdhesivePrice++
      }
      if (product.disabledSealerPriceDefender && hasFinishId) {
        totalDisabledSealerPrice++
      }
      if (product.disabledSealerPriceGold && hasFinishId) {
        totalDisabledSealerPrice++
      }

      let quoteProductCalculators = Array.isArray(product.quoteProductCalculators) ? product.quoteProductCalculators : [];
      quoteProductCalculators?.map((calc: any) => {
        const isSelected = calc.is_selected == true || calc.total_price === 0;
        switch (calc.type) {
          case constants.CONSUMABLE_CALCULATOR_TYPE_DEFENDER:
          case constants.CONSUMABLE_CALCULATOR_TYPE_GOLD:
            if (hasFinishId) {
              totalPremiumSealing++;
              if (isSelected) totalSelectedPremiumSealing++;
            }
            break;

          case constants.CONSUMABLE_CALCULATOR_TYPE_ADHESIVE:
            if (hasGlueCalc) {
              totalAdhesive++;
              if (isSelected) totalSelectedAdhesive++;
            }
            break;
        }
      });
    });
  }

  // A standalone consumable line item (consumable_id set, no product_id) carries no per-product
  // calculator, so every counter above stays 0 and the `total == totalDisabled` test below resolves
  // to 0 == 0 = "hide". On a consumables-only quote that hid the Premium Adhesive and Premium Sealer
  // rows, which are the only rows holding its value — the summary then showed an RRP and a Sub Total
  // with nothing in between to explain them. Keep both rows visible whenever such a line exists.
  const hasStandaloneConsumableLine = (modelOrder.quote_product || [])
    .some((line: any) => line?.consumable_id && !line?.product_id);

  /* ################### Hide Disabled Total Premium Adhesive/Sealer Start ################### */
  modelOrder.disabledTotalAdhesivePrice = hasStandaloneConsumableLine
    ? false
    : (totalAdhesive >= 0 && totalDisabledAdhesivePrice >= 0 && totalAdhesive == totalDisabledAdhesivePrice ? true : false);
  modelOrder.disabledTotalPremiumSealingPrice = hasStandaloneConsumableLine
    ? false
    : (totalPremiumSealing >= 0 && totalDisabledSealerPrice >= 0 && totalPremiumSealing == totalDisabledSealerPrice ? true : false);
  /* ################### Hide Disabled Total Premium Adhesive/Sealer End ################### */

  /* ################### Select/Unselect Premium Adhesive/Sealer Start ################### */
  modelOrder.is_select_premium_sealing = totalPremiumSealing > 0 && totalSelectedPremiumSealing > 0 && totalPremiumSealing == totalSelectedPremiumSealing ? true : false;
  modelOrder.is_select_adhesive = totalAdhesive > 0 && totalSelectedAdhesive > 0 && totalAdhesive == totalSelectedAdhesive ? true : false;
  /* ################### Select/Unselect Premium Adhesive/Sealer End ################### */
}

export function calculateConsumableSummary(quoteProducts: any, defenderConst: string, goldConst: string) {
  let consumableSummary = [];
  let defenderTotalUnit = 0;
  let defenderTotalPrice = 0;
  let goldTotalUnit = 0;
  let goldTotalPrice = 0;
  let defender500TotalUnit = 0;
  let defender2500TotalUnit = 0;
  let defender5000TotalUnit = 0;
  let defender15000TotalUnit = 0;
  let gold500TotalUnit = 0;
  let gold2500TotalUnit = 0;
  let gold5000TotalUnit = 0;
  let gold15000TotalUnit = 0;
  if (quoteProducts.length >= 1) {
    quoteProducts?.map((product: any) => {
      let quoteProductCalculators = Array.isArray(product?.quoteProductCalculators) ? product.quoteProductCalculators : [];
      quoteProductCalculators?.map((consumableCalculator: any) => {
        if (consumableCalculator.is_selected == true && (consumableCalculator.type == defenderConst)) {
          defenderTotalPrice = (defenderTotalPrice + consumableCalculator.total_price);
          defenderTotalUnit = (defenderTotalUnit + consumableCalculator.total_unit);
          defender500TotalUnit = (defender500TotalUnit + consumableCalculator.summary['500ML']);
          defender2500TotalUnit = (defender2500TotalUnit + consumableCalculator.summary['2500ML']);
          defender5000TotalUnit = (defender5000TotalUnit + consumableCalculator.summary['5000ML']);
          defender15000TotalUnit = (defender15000TotalUnit + consumableCalculator.summary['15000ML']);
        } else if (consumableCalculator.is_selected == true && (consumableCalculator.type == goldConst)) {
          goldTotalPrice = (goldTotalPrice + consumableCalculator.total_price);
          goldTotalUnit = (goldTotalUnit + consumableCalculator.total_unit);
          gold500TotalUnit = (gold500TotalUnit + consumableCalculator.summary['500ML']);
          gold2500TotalUnit = (gold2500TotalUnit + consumableCalculator.summary['2500ML']);
          gold5000TotalUnit = (gold5000TotalUnit + consumableCalculator.summary['5000ML']);
          gold15000TotalUnit = (gold15000TotalUnit + consumableCalculator.summary['15000ML']);
        }
      });
    });
  }

  let defenderSummary = {
    type: 'defender',
    total_price: defenderTotalPrice,
    total_unit: defenderTotalUnit,
    five_hundred_total_unit: defender500TotalUnit,
    two_thousand_five_hundred_total_unit: defender2500TotalUnit,
    five_thousand_total_unit: defender5000TotalUnit,
    fifteen_thousand_total_unit: defender15000TotalUnit
  };

  let goldSummary = {
    type: 'gold',
    total_price: goldTotalPrice,
    total_unit: goldTotalUnit,
    five_hundred_total_unit: gold500TotalUnit,
    two_thousand_five_hundred_total_unit: gold2500TotalUnit,
    five_thousand_total_unit: gold5000TotalUnit,
    fifteen_thousand_total_unit: gold15000TotalUnit
  };

  consumableSummary.push(defenderSummary);
  consumableSummary.push(goldSummary);
  return consumableSummary;
}

export function calculateTotalPremiumSealingAndAdhesivePrice(quoteProducts, consumableCalculatorTypeAdhesive: any, consumableCalculatorTypeDefender: any, consumableCalculatorTypeGold: any, calculate = false) {
  if (!quoteProducts?.length) return;

  let totalPremiumSealingPrice = 0;
  let totalAdhesivePrice = 0;
  quoteProducts.forEach((product: any) => {
    const calculators = Array.isArray(product?.quoteProductCalculators)
      ? product.quoteProductCalculators
      : [];
    const baseProduct = product.product || {};

    product.disabledAdhesivePrice = true;
    product.disabledSealerPriceDefender = true;
    product.disabledSealerPriceGold = true;

    calculators.map((calculator: any) => {
      const {type, total_price, is_selected} = calculator;

      if (total_price > 0) {
        // Custom products (Non-Master SKU) are auto-created by the Unleashed sync, which never
        // maps apply_glue_calculator / consumables_* — they land on the schema default 'NO' with
        // NULL consumable attributes. Gating on the product row therefore hid the Premium Adhesive
        // line on every Unleashed-synced order even though the API returned the calculator with a
        // real total_unit/total_price. For a custom product the applied-calculator row is the
        // authoritative source, so trust it instead. (The Premium Sealer block already has the
        // equivalent is_custom_product allowance in product-detail-section.component.html.)
        if (type === consumableCalculatorTypeAdhesive &&
          (baseProduct.apply_glue_calculator === 'YES' || baseProduct.is_custom_product)) {
          product.disabledAdhesivePrice = false;
        }

        // Same reasoning as the adhesive gate above — the Unleashed sync leaves consumables_finish_id
        // NULL on custom products, so gating on the product row kept both sealer flags disabled and
        // hid the Premium Sealer total. The server does not apply this gate at all:
        // getTotalPremiumSealing() sums the applied DEFENDER/GOLD calculator rows for the quote, so a
        // calculator with total_price > 0 is the authoritative signal that the line carries sealer.
        if (type === consumableCalculatorTypeDefender &&
          (baseProduct.consumables_finish_id || baseProduct.is_custom_product)) {
          product.disabledSealerPriceDefender = false;
        }

        if (type === consumableCalculatorTypeGold &&
          (baseProduct.consumables_finish_id || baseProduct.is_custom_product)) {
          product.disabledSealerPriceGold = false;
        }
      } else {
        const select = () => {
          calculator.is_selected = false;
        };

        switch (type) {
          case consumableCalculatorTypeAdhesive:
            product.disabledAdhesivePrice = true;
            if (is_selected) select();
            break;

          case consumableCalculatorTypeDefender:
            product.disabledSealerPriceDefender = true;
            if (is_selected) select();
            break;

          case consumableCalculatorTypeGold:
            product.disabledSealerPriceGold = true;
            if (is_selected) select();
            break;

          default:
            product.disabledAdhesivePrice = false;
            product.disabledSealerPriceDefender = false;
            product.disabledSealerPriceGold = false;
        }
      }

      if (is_selected && calculate) {
        switch (type) {
          case consumableCalculatorTypeAdhesive:
            totalAdhesivePrice += total_price;
            break;
          case consumableCalculatorTypeDefender:
          case consumableCalculatorTypeGold:
            totalPremiumSealingPrice += total_price;
            break;
        }
      }
    });
  });
  return {totalPremiumSealingPrice, totalAdhesivePrice};
}


/** One sealer pack size from the consumables price list (Settings → Consumables Calculator → Pricing). */
export interface SealerPackPrice {
  type: string;   // 'DEFENDER' | 'GOLD'
  size: number;   // millilitres, e.g. 500, 2500, 5000, 15000
  price: number;  // price_per_unit
}

/**
 * Bottle price for a total volume of one sealer, in litres.
 *
 * Mirrors api-v2 calculateSealerPrice (src/utils/helpers/consumableCalculatorFunctions.ts): round the
 * volume up to the next 0.5 L, fill greedily from the largest pack down, and top up with one more of
 * the smallest pack for any remainder. Keep the two in step, or the screen and the saved quote differ.
 */
export function calculateSealerBottlePrice(totalLitres: number, packs: SealerPackPrice[]): number {
  if (!(totalLitres > 0) || !packs?.length) return 0;
  const sizesInLitres = packs.map(p => Number(p.size) / 1000).sort((a, b) => b - a);
  const lastSize = sizesInLitres[sizesInLitres.length - 1];
  let remaining = Math.ceil(totalLitres / 0.5) * 0.5;
  let total = 0;
  for (const size of sizesInLitres) {
    const division = remaining / size;
    const modulo = remaining % size;
    let count = 0;
    if (division >= 1) {
      count = Math.round(division);
      if (count * size > remaining) count -= 1;
    }
    if (size === lastSize && modulo <= size && modulo !== 0) count += 1;
    const pack = packs.find(p => Number(p.size) === Math.round(size * 1000));
    if (pack) total += count * Number(pack.price);
    remaining = modulo;
  }
  return total;
}

/**
 * Re-price the ticked Defender and Gold calculators on the COMBINED litres of the whole quote and
 * split each type's total across its lines by volume.
 *
 * This is what the server does when the quote is saved (api-v2 repriceQuoteConsumables: aggregate
 * units per type, one bottle price, share = total × line units / total units, 2dp). Pricing each line
 * on its own litres made the create and clone screens show a different total from the saved one, e.g.
 * 1.25 L + 1.67 L of Defender as 3 + 4 small bottles instead of one 2.5 L and one 500 ml bottle.
 *
 * Only ticked rows count, as only ticked rows are saved. Unticked rows keep their per-line offer price.
 */
export function redistributeSealerOnCombinedLitres(
  quoteProducts: any[],
  packs: SealerPackPrice[],
  defenderType: string,
  goldType: string
): void {
  if (!quoteProducts?.length || !packs?.length) return;
  for (const [calculatorType, packType] of [[defenderType, 'DEFENDER'], [goldType, 'GOLD']]) {
    const typePacks = packs.filter(p => p.type === packType);
    const rows = new Set<any>();
    for (const product of quoteProducts) {
      for (const list of [product?.quoteProductCalculators, product?.consumable_calculators]) {
        for (const calculator of (Array.isArray(list) ? list : [])) {
          if (calculator?.type === calculatorType && calculator?.is_selected && Number(calculator?.total_unit) > 0) {
            rows.add(calculator);
          }
        }
      }
    }
    const totalUnits = [...rows].reduce((sum, row) => sum + Number(row.total_unit), 0);
    if (!(totalUnits > 0)) continue;
    const orderTotal = calculateSealerBottlePrice(totalUnits, typePacks);
    if (!(orderTotal > 0)) continue;
    for (const row of rows) {
      const share = +(orderTotal * (Number(row.total_unit) / totalUnits)).toFixed(2);
      row.total_price = share;
      row.discounted_price = share;
    }
  }
}
